import { Checkbox, type CheckboxProps } from 'antd';
import clx from 'classnames';
import styled from 'styled-components';
import { useInputController } from '../../hooks/useInputController.ts';
import { useFormItemAccessibility } from '../../item/useFormItemAccessibility.tsx';

const StyledComputedCheckbox = styled(Checkbox)`
  &.read-only {
    pointer-events: none;
  }
`;

export interface IComputedCheckboxInputProps
  extends Omit<CheckboxProps, 'name'> {
  name: string;
  /**
   * Aggungiamo proprietà readOnly non gestita da antd
   */
  readOnly?: boolean;
}

/**
 * Simile al checkbox input, ma il valore è statico e non può essere modificato
 * dall'utente. Il campo viene comunque registrato nel form.
 *
 * Il valore nel form state viene aggiornato centralmente da `syncComputedValues`.
 */
export function ComputedCheckboxInput(props: IComputedCheckboxInputProps) {
  const { name, readOnly, className, ...inputProps } = props;

  const {
    field: { value },
  } = useInputController(name, { enabled: true, skipComputedSync: true });

  const accessibility = useFormItemAccessibility();

  return (
    <StyledComputedCheckbox
      {...accessibility.attributes}
      {...inputProps}
      checked={value}
      disabled={false}
      onChange={() => {}}
      className={clx(className, { 'read-only': readOnly })}
    />
  );
}
